module.exports = __webpack_public_path__ + "img/bg-warning.4a5a23ea.png";